import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('health-board', 'payment-orders');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['appointmentId'],
    },
    'payment_orders',
    {
      type: 'payload.query',
      queryParameter: 'coupon_identifier',
      selector: 'coupon',
    },
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/payment-order-req.js